<template>
	<div class="w-full body-bg">
		<div class="h-img-block">
			<img class="h-img" src="../assets/2.png" />
<!--			<p>V 1.50</p>-->
		</div>
		<div class="login">
			<div class="login-form">
				<div class="login-form_title">
					<p>{{ title }}</p>
					<a href="http://www.gzsrqxh.cn/">官网首页</a>
				</div>
				<input class="login-form_item margin-top-29" placeholder="请输入设置的中文字符的登录账号" name="userName" type="text"
					v-model="userName" />
				<div v-if="wUserName" class="font-wraing">
					<img class="wraing-icon" src="../assets/3.png" /><span>{{ wUserName}}
					</span>
				</div>
				<input class="login-form_item" name="paw" placeholder="请输入您的登录密码" type="password" v-model="paw" />
				<div v-if="wPaw" class="font-wraing">
					<img class="wraing-icon" src="../assets/3.png" /><span>{{wPaw}}</span>
				</div>
				<!-- <div class="pos-input">
          <input
            class="login-form_item margin-top-0"
            name="keyword"
            type="number"
            placeholder="请输入短信验证码"
            v-model="code"
          />
          <div class="code-block">发送验证码</div>
        </div>
        <div v-if="wCode" class="font-wraing">
          <img class="wraing-icon" src="../assets/3.png" /><span>{{
            wCode
          }}</span>
        </div> -->
				<div class="login-form_assist">
					<input class="login-form_assist_isAgree" type="checkbox" v-model="pawRemember" @click="checkbox()" /><span style="color:#71767C">记住我</span>
					<router-link to="/forgetPassword">忘记密码?</router-link>
				</div>
				<button class="login-but" @click="login">登录系统</button>
				<button class="login-register" @click="onRegisterTap">
					还没账号？立即注册
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		IsName,
		IsPaw,
		// IsCode
	} from "../utils/validate";
	import {
		Login
	} from "../utils/api.js"
	export default {
		name: "Login",
		components: {},
		data() {
			return {
				title:"非会员单位登录",
				userName: "",
				wUserName: "", //用户名提示
				paw: "",
				wPaw: "", //密码提示
				code: "",
				wCode: "", //验证码提示
				pawRemember: false, //是否记住密码
			};
		},
		created(){
			if (this.$route.query.title==1) {
				this.title = '非会员单位登录'
			}else{
				this.title = '会员单位登录'
			}
			let userinfo = JSON.parse(localStorage.getItem('userandpas'))
			if (userinfo==null) {
				return false
			}
			this.userName = userinfo.uesr
			this.paw = userinfo.paw
			this.pawRemember = userinfo.pawRemember


		},
		methods: {
			onRegisterTap() {
				this.$router.push({
					path: "register"
				});
			},
			// 选中为true,未选中为false
			checkbox() {
				this.pawRemember = event.target.checked;
				let obj = {
					uesr:this.userName,
					paw:this.paw,
					pawRemember:this.pawRemember
				}
				if (this.pawRemember) {
					localStorage.setItem('userandpas',JSON.stringify(obj))
				}else{
					localStorage.removeItem('userandpas')
				}
			},
			login() {
				if (
					IsName(this, this.userName, "账号密码") &&
					IsPaw(this, this.paw, "登录密码")
				) {
					const data = {
						name: this.userName,
						password: this.paw
					}
					Login(data).then(res => {
						console.log(res)
						localStorage.setItem("TOKEN", res.access_token)
                        localStorage.setItem("USERDATE", "{\"phone\":\""+res.user.phone+"\"}");
						//直接跳转
						this.$router.push({
							path: '/member/infor',
						});
					}).catch(err => {
						console.log(err)
						this.$message.error(err);
					})
				}
			},
		},
	};
</script>
<style lang="less" scoped>
	body {
		width: 100%;
		height: 100%;
	}

	.w-full {
		width: 100%;
		height: 100%;
	}

	.body-bg {
		background: url("../assets/1.png");
		background-size: cover;
		background-repeat: no-repeat;
		overflow: hidden;
		height: 100%;

		.h-img-block {
			width: 500px;
			margin: 0 auto;
			margin-top: 20px;
			text-align: center;
			display: flex;
			justify-content: center;
			align-items: flex-end;
			p{
				margin-bottom: 20px;
				font-size: 15px;
				font-family: Source Han Sans CN;
				font-weight: bold;
				line-height: 21px;
				color: #FFFFFF;
				text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.66);
			}
			.h-img {
				width: 201px;
				height: 206px;
			}
		}

		.login {
			margin-top: 43px;

			.login-form {
				width: 412px;
				//  height: 473px;
				background: #fff;
				margin: 0 auto;
				padding: 20px 20px 40px 22px;

				&_title {
					color: #272f3c;
					font-size: 24px;
					font-weight: bold;
					line-height: 26px;
					text-align: left;
					border-bottom: 1px solid #dbdbdb;
					padding-bottom: 18px;
					display: flex;
					align-items: center;
					justify-content: space-between;
					a{
						font-size: 16px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						line-height: 14px;
						color: #9FA6AF;
						position: relative;
						&::before{
							content: '';
							display: block;
							width: 14px;
							height: 14px;
							background-image: url('../assets/backhome.png');
							background-size: 100% 100%;
							position: absolute;
							left: -18px;
						}
					}
				}

				&_item {
					width: 288px;
					height: 42px;
					border: 1px solid #bdc3cb;
					padding: 0px 11px;
					font-size: 14px;
					// margin-left: 32px;
					margin-top: 19px;
				}

				.margin-top-29 {
					margin-top: 29px;
				}

				.pos-input {
					position: relative;
					//  width: 100%;
					height: 42px;
					margin-top: 18px;

					.margin-top-0 {
						margin-top: 0px;
					}

					.code-block {
						position: absolute;
						top: 0px;
						right: 50px;
						width: 102px;
						height: 42px;
						text-align: center;
						line-height: 42px;
						color: #194abe;
						border: 1px solid #194abe;
						font-size: 14px;
						cursor: pointer;
					}
				}

				.login-form_assist {
					width: 302px;
					//   height: 60px;
					//  line-height: 60px;
					margin-top: 15px;
					margin-left: 53px;
					margin-bottom: 19px;
					text-align: left;

					&_isAgree {
						display: inline-block;
						margin-right: 8px;
                        width: 18px;
                        height: 18px;
                        font-size: 12px;
                        vertical-align: middle;
                        margin-top:-2px;
					}
                    &_isAgree::after{
                        top: 0;
                        color: #000;
                        width: 18px;
                        height: 18px;
                        display: inline-block;
                        visibility: visible;
                        padding-left: 0px;
                        text-align: center;
                        content: ' ';
                    }

					&_isAgree:checked::after {
                        content: "✓";
                        color: #fff;
                        background-color: #FF8640;
                        font-size: 12px;
                        font-weight: bold;
					}

					a {
						float: right;
						text-decoration: underline;
						color: #71767c;
						font-size: 14px;
					}
				}

				.login-but {
					width: 302px;
					height: 48px;
					background: #3D63DF;
					opacity: 1;
					border-radius: 6px;
					// margin-left: 32px;
					color: #fff;
					font-size: 16px;
					font-weight: bold;
					border: none;
					cursor: pointer;
				}

				.login-register {
					width: 302px;
					height: 48px;
					background: #ffffff;
					opacity: 1;
					border-radius: 6px;
					// margin-left: 32px;
					color: #FF8640;
					font-size: 16px;
					font-weight: bold;
					margin-top: 24px;
					text-align: center;
					line-height: 48px;
					border: 1px solid #FF8640;
					cursor: pointer;
					border-radius: 6px;
				}

				.font-wraing {
					color: #ff7476;
					font-size: 14px;
					margin-left: 52px;
					margin-top: 6px;
					text-align: left;
				}

				.wraing-icon {
					display: inline-block;
					margin-right: 10px;
				}
			}
		}
	}
</style>
